import { NGXLogger } from 'ngx-logger';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DataService } from 'src/app/shared/services/data.service';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { KEYS } from 'src/app/shared/constants/keys';
import { CookieService } from 'ngx-cookie-service';
import { IdleService } from 'src/app/shared/services/idle.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.less'],
    standalone: false
})
export class LoginComponent implements OnInit {
  hide = true;
  login:FormGroup;
  trackingPath: string = "open-tracking";

  constructor(private router:Router,
    private formBuilder:FormBuilder,
    private service: DataService,
    private logger: NGXLogger,
    private cookieService: CookieService,
    private idleService: IdleService,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    const creds=this.cookieService.get('grt-client-creds')? JSON.parse(this.cookieService.get('grt-client-creds')) : undefined;
    this.login = this.formBuilder.group({
      email: [creds?creds.email:'',[Validators.required,Validators.email]],
      password: [creds?creds.password:'',[Validators.required]],
      rememberMe: [creds?true:false],
      userType: ['CLIENT'] // THIS VALUE MUST BE ALWAYS 'CLIENT' FOR THIS CLIENT PORTAL
    })
    this.checkSessionExpiry();
  }

  async onSubmit() {
    this.login.markAllAsTouched();
    if(this.login.valid){
      this.rememberMe ? this.cookieService.set('grt-client-creds',JSON.stringify(this.login.value)) : this.cookieService.delete('grt-client-creds');
      this.logger.info('remember me value',this.cookieService.get('grt-client-creds'));
      this.service.post(Api.login, this.login.value).subscribe(res => {
        if (res.accesstoken) {
          localStorage.setItem(KEYS.ACCESS_TOKEN,res.accesstoken);
          localStorage.setItem(KEYS.REFRESH_TOKEN,res.refreshtoken);
          this.idleService.reset();
          this.getAuthority();
          this.getClientid();
        }
      }); 
      sessionStorage.setItem(KEYS.USER_ID,"admin");
    }
  }

  private getAuthority() {
    this.service.get(Api.AUTHORITY).subscribe(res => {
      this.logger.info('authority : ', res);
      if (res.authorities.includes('ROLE_GSA')) {
        this.service.get(Api.USER_COMPANY_LIST).subscribe((res) => {
          this.logger.info("company list new ", res);
        });
        this.router.navigate([APP_ROUTES.dashboard]);
      } else {
        this.logger.info('redirecting to company selection page');
        this.router.navigate([APP_ROUTES.COMPANY_SELECTION]);
      }
      this.setPermissions(res);
      this.storeRole(res);
    });
  }

  private setPermissions(res: any) {
    if (res.permission) {
      this.logger.info('User Permission Module Map : ', res.permission);
      localStorage.setItem(KEYS.PERMISSION_DATA, JSON.stringify(res.permission));
    }
  }

  private storeRole(response){
    let userRole:string;
    if(response.authorities.includes('ROLE_GSA')){
      userRole = 'ROLE_GSA';
    }else if(response.authorities.includes('ROLE_CSA')){
      userRole = 'ROLE_CSA';
    }else if(response.authorities.includes('ROLE_BSA')){
      userRole = 'ROLE_BSA';
    }else {
      userRole = 'ROLE_USER';
    }
    localStorage.setItem(KEYS.ROLE,userRole);
  }

  private getClientid()
  {
     this.service.get(Api.GET_CLIENT_ID).subscribe(res => {
       if(res)
       {
         localStorage.setItem('CLIENT_ID',res.clientId);
       }
     })
  }

  openTracking(){
    this.router.navigate([APP_ROUTES.OPEN_TRACKING]);
  }

  private checkSessionExpiry(): void {
    const expired = sessionStorage.getItem('sessionExpired');
    if (expired === 'true') {
      this.snackBar.open('⚠️ Session expired. Please log in again.', 'Close', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['timeout-snackbar']
      });
      sessionStorage.removeItem('sessionExpired');
    }
  }


  get email(){return this.login.get('email');}
  get password(){return this.login.get('password');}
  get rememberMe(){return this.login.get('rememberMe').value;}
}
